import { remaining } from './locales';
import getCurrentLanguageKey from '../getCurrentLanguageKey';

import calculateTimeDifference from './calculateTimeDifference';

const remainingTime = (date: string | Date, lang?: 'es' | 'pt') => {
  const langKey = lang || getCurrentLanguageKey();

  return calculateTimeDifference(date, remaining[langKey]);
};

export default remainingTime;
